import { render, staticRenderFns } from "./UploadRecording.vue?vue&type=template&id=4eba6374"
import script from "./UploadRecording.vue?vue&type=script&lang=js"
export * from "./UploadRecording.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports